// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: #153A65;
  height: 42px;
  padding-top: 0 !important;
}

h5 {
  color: var(--ion-color-primary);
}

p {
  font-family: var(--font-secondary) !important;
  font-weight: 400;
}

.toolbar-container {
  height: 42px;
}

.game-detail-navbar ion-button {
  width: 65px !important;
  height: 54px;
  transform: translateY(-8px);
  --background-hover-opacity: 0;
}
.game-detail-navbar ion-button ion-icon {
  font-size: 40px !important;
}
@media screen and (max-width: 550px) {
  .game-detail-navbar ion-button {
    /* Add responsive styles here if needed */
  }
}
.game-detail-navbar ion-title {
  text-align: center;
  font-family: var(--font-secondary) !important;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  transform: translateY(-8px);
}
@media screen and (max-width: 550px) {
  .game-detail-navbar ion-title {
    font-size: 22px;
  }
}

ion-content {
  margin: 0;
  padding: 5px 20px;
  height: 100%;
  --background: #153A65;
}

.image-container {
  display: flex;
  min-height: 200px;
}
.image-container img {
  width: 100%;
  max-height: 227px;
  min-height: 200px;
}

p.category-text {
  margin-top: 1px;
  font-size: 17px;
  color: var(--ion-color-light);
  font-weight: 400;
  transform: translateY(-14px);
  text-transform: lowercase;
  font-family: var(--font-secondary) !important;
}
p.category-text::first-letter {
  text-transform: uppercase;
}
@media screen and (max-width: 550px) {
  p.category-text {
    font-size: 16px;
    transform: translateY(-6px);
  }
}

.info-text {
  color: var(--ion-color-light);
}
.info-text h5 {
  margin: 1px !important;
}
.info-text p {
  margin: 8px 0 0 0 !important;
}

ion-button {
  min-height: 40px;
  --border-radius: 1.75rem;
}

.game-detail-description-table {
  margin-top: 16px;
}
.game-detail-description-table table {
  border-collapse: separate;
  width: 100%;
  border: 1px solid #73A6E1;
  overflow: hidden;
  border-radius: 8px;
}
.game-detail-description-table table h5 {
  font-family: var(--font-secondary) !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 17.07px;
  text-align: left;
  color: var(--ion-color-light);
}
.game-detail-description-table table h5 span.normal-weight {
  font-weight: 500;
}
.game-detail-description-table table h5 span {
  font-weight: 700;
}
.game-detail-description-table table td {
  padding-left: 16px;
}
.game-detail-description-table .game-detail-table td {
  border-bottom: 1px solid #73A6E1;
}
.game-detail-description-table .game-detail-table tr:last-child td {
  border-bottom: none;
}

.game-detail-description-box {
  background-color: #E8F7FF;
  padding: 16px;
  margin-top: 16px;
  border-radius: 8px;
}
.game-detail-description-box h5 {
  font-family: var(--font-secondary) !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 17.07px;
  text-align: left;
  color: #000;
}
.game-detail-description-box p {
  font-family: var(--font-secondary) !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  margin: 0px;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/game-details/game-details.component.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,YAAA;EACA,yBAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,6CAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAKE;EACE,sBAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;AAFJ;AAII;EACE,0BAAA;AAFN;AAKI;EAVF;IAWI,yCAAA;EAFJ;AACF;AAKE;EACE,kBAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAHJ;AAKI;EARF;IASI,eAAA;EAFJ;AACF;;AAMA;EACE,SAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;AAHF;;AAMA;EACE,aAAA;EACA,iBAAA;AAHF;AAKE;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,eAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,6CAAA;AAJF;AAME;EACE,yBAAA;AAJJ;AAOE;EAbF;IAcI,eAAA;IACA,2BAAA;EAJF;AACF;;AAOA;EACE,6BAAA;AAJF;AAME;EACE,sBAAA;AAJJ;AAOE;EACE,4BAAA;AALJ;;AASA;EACE,gBAAA;EACA,wBAAA;AANF;;AASA;EACE,gBAAA;AANF;AAQE;EACE,yBAAA;EACA,WAAA;EACA,yBA/GW;EAgHX,gBAAA;EACA,kBAAA;AANJ;AAQI;EACE,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;AANN;AAQM;EACE,gBAAA;AANR;AASM;EACE,gBAAA;AAPR;AAWI;EAEE,kBAAA;AAVN;AAcE;EACE,gCA3IW;AA+Hf;AAeE;EACE,mBAAA;AAbJ;;AAiBA;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAdF;AAgBE;EACE,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;AAdJ;AAiBE;EACE,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAhBF","sourcesContent":["$table-border: 1px solid #73A6E1;\n\nion-toolbar {\n  --background: #153A65;\n  height: 42px;\n  padding-top: 0 !important;\n}\n\nh5 {\n  color: var(--ion-color-primary);\n}\n\np {\n  font-family: var(--font-secondary) !important;\n  font-weight: 400;\n}\n\n.toolbar-container {\n  height: 42px;\n}\n\n.game-detail-navbar {\n  ion-button {\n    width: 65px !important;\n    height: 54px;\n    transform: translateY(-8px);\n    --background-hover-opacity: 0;\n\n    ion-icon {\n      font-size: 40px !important;\n    }\n\n    @media screen and (max-width: 550px) {\n      /* Add responsive styles here if needed */\n    }\n  }\n\n  ion-title {\n    text-align: center;\n    font-family: var(--font-secondary) !important;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 28px;\n    transform: translateY(-8px);\n\n    @media screen and (max-width: 550px) {\n      font-size: 22px;\n    }\n  }\n}\n\nion-content {\n  margin: 0;\n  padding: 5px 20px;\n  height: 100%;\n  --background: #153A65;\n}\n\n.image-container {\n  display: flex;\n  min-height: 200px;\n\n  img {\n    width: 100%;\n    max-height: 227px;\n    min-height: 200px;\n  }\n}\n\np.category-text {\n  margin-top: 1px;\n  font-size: 17px;\n  color: var(--ion-color-light);\n  font-weight: 400;\n  transform: translateY(-14px);\n  text-transform: lowercase;\n  font-family: var(--font-secondary) !important;\n\n  &::first-letter {\n    text-transform: uppercase;\n  }\n\n  @media screen and (max-width: 550px) {\n    font-size: 16px;\n    transform: translateY(-6px);\n  }\n}\n\n.info-text {\n  color: var(--ion-color-light);\n\n  h5 {\n    margin: 1px !important;\n  }\n\n  p {\n    margin: 8px 0 0 0 !important;\n  }\n}\n\nion-button {\n  min-height: 40px;\n  --border-radius: 1.75rem;\n}\n\n.game-detail-description-table {\n  margin-top: 16px;\n\n  table {\n    border-collapse: separate;\n    width: 100%;\n    border: $table-border;\n    overflow: hidden;\n    border-radius: 8px;\n\n    h5 {\n      font-family: var(--font-secondary) !important;\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 17.07px;\n      text-align: left;\n      color: var(--ion-color-light);\n\n      span.normal-weight {\n        font-weight: 500;\n      }\n\n      span {\n        font-weight: 700;\n      }\n    }\n\n    td {\n      // border: $table-border;\n      padding-left: 16px;\n    }\n  }\n\n  .game-detail-table td {\n    border-bottom: $table-border;\n  }\n\n  .game-detail-table tr:last-child td {\n    border-bottom: none;\n  }\n}\n\n.game-detail-description-box {\n  background-color: #E8F7FF;\n  padding: 16px;\n  margin-top: 16px;\n  border-radius: 8px;\n\n  h5 {\n    font-family: var(--font-secondary) !important;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17.07px;\n    text-align: left;\n    color: #000;\n  }\n\n  p {\n    font-family: var(--font-secondary) !important;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 17.07px;\n    text-align: left;\n    margin: 0px\n  }\n}\n\n.button-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
